import { getFileByPath, getFilesData } from "api/fileManager";
import dangerModalApiConfig from "./modal/DangerModal/config/dangerModalApiConfig";

const fileExplorerConfig = {
  getFilesData,
  getFileByPath,
  dangerModalApiConfig
};

export default fileExplorerConfig;